<template lang="pug">
div
 
  PDFModal(
    ref="pdfModal",
    :class_options="options.all_classification_lables",
    v-if="options",
    :config="config",
    @saved="getDocuments(currentproject)",
    :detail_list="detail_list"
  )
  SharepointModal(ref="sharepointModal", :project="currentproject", @importFiles="importFiles")
  ProjectModal(ref="projectModal", @save="createproject")
  ImportModal(
    ref="importModal",
    @save="importDone",
    @complete="importComplete"
  )
  ExcelImportModal(
    ref="excelImportModal", 
    :project-id="currentproject._id",
    @import-complete="handleImportComplete"
  )
  base-header(ref="base")
    b-row.py-3(aling-v="center")
      b-col(cols="8", lg="8")
        h6.h2.text-white.d-inline-block.mb-0(v-if="currentproject") 
          |
          i.fa.fa-folder-tree.text-muted.mr-1
          | {{ currentproject.name }}
          b-btn(
            v-if="currentproject",
            variant="outline-light",
            size="sm",
            @click="$refs.projectModal.open(currentproject)"
          ).ml-2
            i.fa.fa-edit
        .small.text-muted(v-if="currentproject") {{ currentproject.relations.total_documents }} Dokumente
        b-row.mt-1
      b-col(cols="4")
        .d-flex.justify-content-between(v-if="projects")
          div
            el-select.select-primary.pagination-select.w-100.mt-1(
              size="sm",
              v-model="selectedProjects",
              @change="getProject(selectedProjects)",
              placeholder="Projekt wählen",
              :filterable="true",
              popper-class="custom-select-dropdown"
            )
              template(v-if="projects")
                template(v-for="item in projects", v-if="!item.archived_at || show_archived")
                  el-option(
                    :key="item._id",
                    :label="item.name",
                    :value="item._id"
                  )
            
            b-checkbox(
              v-model="show_archived",
              size="sm"
              class="ml-2 text-white",
            ) Archivierte anzeigen

          //b-select(
              v-model="selectedProject",
              :options="projects",
              size="sm",
              @change="getProject(selectedProject)",
              placeholder="Projekt wählen",
              text-field="name",
              value-field="_id"
            )
          b-button.text-nowrap.ml-1(@click="$refs.projectModal.open()", size="sm") Neues Projekt

    b-row.py-1(aling-v="center", v-if="currentproject !== undefined")
      b-col.small(cols="8", lg="8", v-if="currentproject")
        b-link.subm.mr-4(
          v-if="currentproject",
          :to="'/dashboard/' + currentproject._id + '?page=pre_list'",
          v-bind:class="{ submactive: $route.query.page == 'list' }"
        ) 
          |
          i.fa.fa-list.mr-2
          | Anforderungsliste
        b-link.subm.mr-4(
          v-if="currentproject",
          :to="'/dashboard/' + currentproject._id + '?page=documents'",
          v-bind:class="{ submactive: $route.query.page == 'documents' || !$route.query.page }",
          
        ) 
          |
          i.fa.fa-file-alt.mr-2
          | Dokumente
        b-link.subm.mr-4(
          v-if="currentproject",
          :to="'/dashboard/' + currentproject._id + '?page=export'",
          v-bind:class="{ submactive: $route.query.page == 'export' }"
        ) 
          |
          i.fa.fa-file-export.mr-2
          | Export

  //
  // Detail list
  //

  b-container(fluid, v-if="form && $route.query.page == 'pre_list'")
    .mt-5.text-center.w-100 
      |
      .small Lade Anforderungsliste ...
   
  b-container(fluid, v-if="form && $route.query.page == 'list'")
    b-row.mt-2(v-if="currentproject")
   
      b-col.mt-2(cols="12")
        .d-flex.justify-content-between.my-2
          div
            b-button(
              @click="check_deltalist(currentproject)",
              size="sm",
              variant="primary"
            )
              i.fas.fa-sync-alt.mr-1
              | Anforderungsliste abgleichen
            
            b-button(
              @click="show_automatically_added = !show_automatically_added",
              size="sm",
              variant="primary"
            )
              template(v-if="!show_automatically_added")
                i.fas.fa-eye.mr-1()
                | Autom. hinzugefügte anzeigen
              template(v-else)
                i.fas.fa-eye-slash.mr-1()
                | Autom. hinzugefügte verbergen

          div
            //b-button(variant="outline-secondary", @click="detail_list.push('')", size="sm") Neue KKS
            b-button(
              variant="outline-secondary",
              @click="$refs.importModal.open(currentproject)",
              size="sm"
            ) Importieren
            b-button(
              variant="outline-secondary",
              :href="base_url + '/projects/' + currentproject._id + '/detail_list?export=true'",
              target="_blank",
              size="sm"
            ) Exportieren
            b-button(
              :href="base_url + '/projects/' + currentproject._id + '/detail_list?export=true&delta=true'",
              size="sm",
              target="_blank"
            )
              | Exportiere Delta-Liste

            //b-button(variant="primary", @click="detail_list.push('')", size="sm") Speichern

       
        // Pagination controls at the top
        b-row.mt-2.mb-2(v-if="detail_list.entries && detail_list.entries.length > entriesPerPage")
          b-col.d-flex.align-items-center
            span.mr-2.small Einträge pro Seite: {{ entriesPerPage }}
            span.mx-2.small Seite {{ currentListPage }} von {{ totalListPages }}
          b-col.d-flex.justify-content-end
            b-pagination(
              v-model="currentListPage",
              :total-rows="detail_list.entries.filter(item => !item.is_automatically_added || show_automatically_added).length",
              :per-page="entriesPerPage",
              align="right",
              size="sm",
              @change="changeListPage"
            )

        b-table-simple(
          responsive,
          small,
          sticky-header="650px",
          border-collapse="collapse",
          border-spacing="0",
          border="0",
          cellpadding="0",
          cellspacing="0"
        )
          thead
            b-tr
              b-th No.
              b-th Autom. <br/> erkannt
              b-th KKS
              b-th Bezeichnung


              template(v-for="classification in detail_list.all_classes")
                b-th.text-center {{ classification }} <br/>
                  |
                  .small(v-if="detail_list.relations && detail_list.relations.dcc_labels") {{ detail_list.relations.dcc_labels[classification] }}

          b-tr(v-for="(it, key) in paginatedEntries", :key="key")
            b-td(style="width: 10px")
              | {{ ((currentListPage - 1) * entriesPerPage) + key + 1 }}
            b-td(style="width: 10px")
              template(v-if="it.is_automatically_added") 
                |
                i.fas.fa-check-circle.text-success
            
            b-td(style="min-width: 200px")
              | {{ it.kks }}

              //template(v-for="did in it.kks_found_documents_ids")
                b-link(@click="$refs.pdfModal.open({project_id: currentproject._id, _id: did})")
                  i.fas.fa-check-circle.text-success.ml-1

              //b-input(v-model="it.kks", size="sm", placehoder="KKS", style="min-width: 180px")
            
            b-td(style="min-width: 200px")
              | {{ it.comment }}
              //b-input(v-model="it.dcc_label", size="sm", placehoder="Bezeichnung", style="min-width: 180px")

            template(v-for="classification in detail_list.all_classes")
              b-td.text-center 
                |
                b(v-if="it.required_classes.includes(classification) || it.kks_classes_found_document_ids.find((x) => x.dcc_class == classification)")
                  b(
                    v-if="it.kks_classes_found_document_ids.find((x) => x.dcc_class == classification)"
                  )
                    template(
                      v-for="ddid in [it.kks_classes_found_document_ids.find((x) => x.dcc_class == classification)]"
                    )
                      span(
                        v-if="it.kks_classes_found_document_ids.filter((x) => x.dcc_class == classification).length > 1"
                      )
                        b-dropdown#dropdown-1(
                          :text="it.kks_classes_found_document_ids.filter((x) => x.dcc_class == classification).length",
                          variant="link",
                          size="sm",
                          no-caret
                        )
                          template(#button-content)
                            i.fas.fa-exclamation-triangle.text-warning {{ it.kks_classes_found_document_ids.filter((x) => x.dcc_class == classification).length }}

                          b-dropdown-item(
                            v-for="(ddid, i) in it.kks_classes_found_document_ids.filter((x) => x.dcc_class == classification)",
                            :key="ddid.document_id"
                          )
                          
                            b-link(
                              @click="$refs.pdfModal.open({ project_id: currentproject._id, _id: ddid.document_id }, checklists)"
                            )
                              i.fas.fa-check-circle.text-success.mr-1 
                              span.d-inline-block.small.text-truncate(style="max-width: 300px") {{ ddid.document_name }} 
                                span(v-if="ddid && ddid.best_date") ( {{ ddid.best_date.text }} ) 
                                
                      span(v-else)
                        b-link(
                          @click="$refs.pdfModal.open({ project_id: currentproject._id, _id: ddid.document_id }, checklists)"
                        )
                          i.fas.fa-check-circle.text-success

                  b(v-else)
                    | X

        // Pagination controls at the bottom
        b-row.mt-4.mb-2(v-if="detail_list.entries && detail_list.entries.length > entriesPerPage")
          b-col.d-flex.align-items-center
            span.mr-2.small Einträge pro Seite: {{ entriesPerPage }}
            span.mx-2.small Seite {{ currentListPage }} von {{ totalListPages }}
          b-col.d-flex.justify-content-end
            b-pagination(
              v-model="currentListPage",
              :total-rows="detail_list.entries.filter(item => !item.is_automatically_added || show_automatically_added).length",
              :per-page="entriesPerPage",
              align="right",
              size="sm",
              @change="changeListPage"
            )

  //
  //  Export
  //            

  b-container(fluid, v-if="form && $route.query.page == 'export'")
    b-row.mt-3(v-if="currentproject")
      b-col.mt-3(cols="12")
        .bg-gray.w-100.p-2
          b-form
            .form-group
              .small.mb-2.text-white(for="projectName") Export Ordner:
              b-input.w-50(
                placeholder="Zielordner name",
                size="sm",
                v-model="currentproject.export_dir_path"
              )

            .d-flex.d-wrap.items-center
              b-button(
                variant="primary",
                @click="exportProject(currentproject)",
                size="sm",
                :disabled="!currentproject.export_dir_path"
              ) Alle Dokumente exportieren
              b-button.ml-2(
                variant="outline-primary",
                size="sm",
                :href="config.sharepoint_export_folder",
                target="_blank"
              )
                i.fas.fa-external-link-alt.mr-1
                | Export-Ordner öffnen

    b-row.mt-5(v-if="currentproject")
      b-col(cols="12")
        h5 Datei-Konfiguration
        b-form
          //div.form-group()
            label(for="projectName") Name Delta-Liste
            b-input.form-control(type="text", v-model="currentproject.export_config.delta_list_name", required, size="sm")

          .form-group
            b-input-group.w-50
              b-input.form-control.w-25(
                type="text",
                v-model="currentproject.export_config.filename_pattern",
                required,
                size="sm"
              )
              b-btn(
                @click="saveProject(currentproject)",
                size="sm",
                variant="outline-secondary",
                :disabled="!currentproject.export_config.filename_pattern"
              ) Speichern
            .small.text-muted.mt-2
            // Help icon

            i.fas.fa-question-circle.mr-2
            .small.d-inline-block Es können die Variablen {kks}, {dcc}, {dcc_label}, {original_file_name}, {project_name}, {sm_Sachmerkmal} im Dateinamen verwendet werden.

      b-col(cols="12")

  // 
  //  Document list
  //
  b-container(
    fluid,
    v-if="form && ($route.query.page == 'documents' || !$route.query.page)"
  ).mt-4
    b-button(
      @click="$refs.sharepointModal.open('ROOT')",
      size="sm",
      variant="primary"
    ) PDFs Importieren
    b-button.ml-2(
      @click="$refs.excelImportModal.open()",
      size="sm",
      variant="primary"
    ) Excel Importieren


  DocumentList(
      :form="form"
      :currentproject="currentproject"
      :documents="documents"
      :select_all_query="select_all_query"
      :bulk_operation="bulk_operation"
      :bulk_value="bulk_value"
      :checklists="checklists"
      :detail_list="detail_list"
      :filter="filter"
      :loadingDocuments="loadingDocuments"
      @bulkOperation="bulkOperation"
      @updateSelectAllQuery="select_all_query = $event"
      @deleteproject="deleteproject"
      @getDocuments="getDocuments"
      @deleteDocument="deleteDocument"
      @updateBulkOperation="bulk_operation = $event; console.log('bulk_operation', bulk_operation)"
      :pdfModal="$refs.pdfModal"
  )

</template>
<script>
// Charts
import PDFModal from "./PDFModal.vue";
import SharepointModal from "./SharepointModal.vue";
import ProjectModal from "./ProjectModal.vue";
import ImportModal from "./ImportModal.vue";
import DocumentList from "./DocumentList.vue";
import ExcelImportModal from "./ExcelImportModal.vue";


import DropzoneFileUpload from "@/components/Inputs/DropzoneFileUpload";



export default {
  components: {
    DropzoneFileUpload,
    ImportModal,
    SharepointModal,
    PDFModal,
    ProjectModal,
    DocumentList,
    ExcelImportModal
  },
  data() {
    return {
      show_archived: false,
      selectedProjects: null,
      loadingDocuments: false,
      currentPage: 1,
      currentListPage: 1,
      entriesPerPage: 250,
      detail_list: {},
      show_automatically_added: false,
      search_request: null,
      is_fetching_documents: false,
      checklists: [],
      extractions: [{"_id": "1", "label": "Extraktion Fördertechnik"}],
      bulk_value: {
        overwrite_extraction: false,
        selected_extraction: [],
        selected_kks: [],
        selected_class: [],
        should_be_splitted: "false",
        export_original_as_complete: "false",
        output_directory: "",
        status: "",
        status_comment: "",
      },
      filter: {
        filename: "",
        selected_kks: [],
        selected_class: [],
        should_be_splitted: "",
        export_original_as_complete: "",
        best_date: "",
        status: "",
        status_comment: "",
        reviewed: null,
        reviewed_comment: ""
      },
      filter_active: {
        filename: false,
        selected_kks: false,
        selected_class: false,
        should_be_splitted: false,
        best_date: false,
        export_original_as_complete: false,
        status: "",
        status_comment: "",
      },
      select_all: false,
      select_all_query: false,
      bulk_operation: "",
      bulk_operation_value: "",
      displayCheck: false,
      init_form: {},
      inputs: { fileMultiple: [] },
      options: null,
      checked_documents: [],
      documents: null,
      config: null,
      form: null,
      selectedProject: null,
      sort_by: "filename",
      desc: false,
      projects: [],
      projectAdd: false,
      currentproject: null,
      ulConfig: {
        maxFilesize: 500,
        acceptedFiles: "application/pdf",
        withCredentials: true,
        previewsContainer: null,
        disablePreviews: false,
        dictDefaultMessage: "Dateien hochladen",
      },
      stats: null,
      recommendations: null,
      user_settings: null,
      network: null,
      statuses: [],
      selectedTopic: null,
      interval: null,
      categories: [],

      technologies: [],

      trends: {},
    };
  },
  computed: {
    paginatedEntries() {
      if (!this.detail_list.entries) {
        return [];
      }

      const startIndex = (this.currentListPage - 1) * this.entriesPerPage;
      const endIndex = startIndex + this.entriesPerPage;
      
      // Filter by automatically added if needed
      const filteredEntries = this.detail_list.entries.filter(
        item => !item.is_automatically_added || this.show_automatically_added
      );
      
      // Calculate total pages
      this.totalListPages = Math.ceil(filteredEntries.length / this.entriesPerPage);
      
      // Return the slice for current page
      return filteredEntries.slice(startIndex, endIndex);
    },
    totalListPages() {
      if (!this.detail_list.entries) {
        return 1;
      }
      
      const filteredEntries = this.detail_list.entries.filter(
        item => !item.is_automatically_added || this.show_automatically_added
      );
      
      return Math.ceil(filteredEntries.length / this.entriesPerPage);
    }
  },
  methods: {
    bulkOperation(project, bulk_operation, bulk_value) {

      
      let document_ids = this.documents
        .filter((doc) => {
          return doc.relations.selected;
        })
        .map((doc) => {
          return doc._id;
        });

      this.bulk_value.output_directory = project.export_dir_path;

      // Confirm bulk operation
      this.$bvModal
        .msgBoxConfirm(
          "Sind Sie sicher diese Bulk-Operation für " +
            (this.select_all_query
              ? this.currentproject.relations.total_documents
              : document_ids.length) +
            " Dokumente auszuführen?",
          {
            title: "Bulk-Operation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Bulk-Operation ausführen",
            cancelTitle: "Abbrechen",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(
          (value) => {
            // User clicked OK
            if (value) {
              this.axios
                .put(
                  this.base_url + "/projects/" + project._id + "/bulk_update",
                  {
                    value: bulk_value,
                    document_ids: document_ids,
                    operation: bulk_operation,
                    filter: this.select_all_query ? this.filter : null,
                  }
                )
                .then((response) => {

                  // if response if export then response should be tuned into file to download xlsx
                  if (bulk_operation == "export_table") {
                    // Log the response data to check its content
                    // response.data has filename, open /projects/{project_id}/export_table_file/{filename} in new tab to download the file

                    window.open(this.base_url + "/projects/" + project._id + "/export_table_file/" + response.data.filename, "_blank");

                }
                  bulk_operation = null;
                  
                  this.getDocuments(this.currentproject);
                  this.getDetailList(this.currentproject, true);
                  this.$bvToast.toast("Bulk-Operation ausgeführt", {
                    title: "Operation",
                    variant: "primary",
                    autoHideDelay: 2000,
                  });
                });
            }
          },
          (reason) => {
            // User clicked cancel
          }
        );
    },
    changeListPage(pageNum) {
      this.currentListPage = pageNum;
    },
    
    check_deltalist(project, quite = false) {
      this.axios
        .post(this.base_url + "/projects/" + project._id + "/detail_list_check")
        .then((response) => {
          if (response && response.data) {
            this.detail_list = response.data;
            
            if (!quite) {
              this.$bvToast.toast("Projekt: " + project.name, {
                title: "Anforderungsliste wird abgeglichen",
                variant: "primary",
                autoHideDelay: 100,
              });
            }
          }
        }).catch((response) => {

        });

    },

    rerun(document) {
      this.axios
        .post(this.base_url + "/documents/" + document._id + "/rerun")
        .then((response) => {
          this.$bvToast.toast(document.filename, {
            title: "Neu gestartet",
            variant: "primary",
            autoHideDelay: 2000,
          });
        });
    },

    importComplete(response) {
      // SHow import successfull
      console.log("res", response);
      this.$bvToast.toast("Import erfolgreich", {
        title: "Import",
        variant: "primary",
        autoHideDelay: 5000,
      });

      this.getDetailList(this.currentproject, false);

    },

    ulFileAdded() {
      console.log(this.inputs.fileMultiple);
    },

    ulComplete(file, project) {
      this.$bvToast.toast(file.name, {
        title: "Uploaded",
        variant: "primary",
        autoHideDelay: 2000,
      });
      console.log(this.$refs["dz" + project._id]);
      this.$refs["dz" + project._id][0].dropzone.removeFile(file);

      console.log(file, project);
      console.log(this.inputs.fileMultiple);
    },

   

    saveProject(project) {
      this.axios
        .put(this.base_url + "/projects/" + project._id, project)
        .then((response) => {
          this.getProjects(true, project._id);
          this.$bvToast.toast("Projekt gepeichert", {
            title: project.name,
            variant: "primary",
            autoHideDelay: 2000,
          });
        });
    },

    exportProject(project) {
      this.axios
        .post(this.base_url + "/jobs/export", {
          configuration: {
            project_id: project._id,
            output_directory: project.export_dir_path,
          },
        })
        .then((response) => {
          this.$bvToast.toast("Export gestartet", {
            title: "Export",
            variant: "primary",
            autoHideDelay: 2000,
          });

          this.getProjects(true, project._id);
        });
    },

    createproject(project) {
      this.currentproject = null;
      if(!project._id) {
        this.axios
        .post(this.base_url + "/projects", project)
        .then((response) => {
          this.currentproject = this.projects.find(
            (m) => m._id == response.data._id
          );
          this.getProjects(true, response.data._id);
        });
      } else {
        this.axios
        .put(this.base_url + "/projects/" + project._id, project)
        .then((response) => {
          this.currentproject = this.projects.find(
            (m) => m._id == response.data._id
          );
          this.getProjects(true, response.data._id);
        });
      }
     
    },

    importDone() {},

    getProject(id) {
      
      this.currentproject = this.projects.find((m) => m._id == id);

      if(!this.currentproject) {
        this.currentproject = this.projects.filter((m) => m.archived_at == null)[0];
      }

      this.selectedProject = id;

      this.getDetailList(this.currentproject, true);
      this.getDocuments(this.currentproject);

      if(this.$route.query.openDocument) {
        this.$refs.pdfModal.open({ project_id: id, _id: this.$route.query.openDocument }, this.checklists);
      }

      console.log("CURRENT", this.currentproject);

      // save to local storage
      localStorage.setItem("currentproject", this.currentproject._id);

      this.$router.replace({
        path: "/dashboard/" + id,
        query: { page: this.$route.query.page },
      });

      

    },

    getProjects(refresh = false, id = null) {
      this.axios.get(this.base_url + "/projects").then((response) => {

        response.data = this.$_.sortBy(response.data, "name");

        this.projects = response.data;

        if (!this.currentproject && !this.$route.params.id) {
          if(localStorage.getItem("currentproject")) {
            this.getProject(localStorage.getItem("currentproject"));
          } else {
            alert("No project selected");
            this.currentproject = this.projects.filter((m) => m.archived_at == null)[0];
            this.getProject(this.currentproject._id);
          }
        } else if (!id && this.$route.params.id) {
          this.getProject(this.$route.params.id);
        } else {
          this.getProject(id);
        }

        if (refresh && this.currentproject) {
          this.getProject(this.currentproject._id);
        }
      });
    },

    getDetailList(project, quite) {
      this.detail_list = {};
      this.currentListPage = 1; // Reset to first page when loading new detail list

      this.axios
        .get(this.base_url + "/projects/" + project._id + "/detail_list")
        .then((response) => {
          if (response && response.data) {
            this.detail_list = response.data;
            //this.check_deltalist(this.currentproject, quite);
          } else {
            this.detail_list = {};
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDocuments(project, page = null, showLoading = true, sort_by = null, order_by = null) { 

      this.sort_by = sort_by ? sort_by : this.sort_by;
      this.desc = order_by !== null ? order_by : this.desc;


      this.is_fetching_documents = true;
      this.loadingDocuments = showLoading;

      if (!page) {
        page = this.currentPage;
      }
      if(page) {
        this.currentPage = page;
      }

      if (project._id == this.currentproject._id) {
        // Save all current selected documents
        let selected_documents = [];
        if (this.documents) {
          selected_documents = this.documents
            .filter((doc) => {
              return doc.relations.selected;
            })
            .map((doc) => {
              return doc._id;
            });
        }

        console.log(this.search_request);

        this.search_request = this.axios
          .post(
            this.base_url + "/projects/" + project._id + "/documents_search",
            {
              page_number: page,
              filter: this.filter,
              sort_by: this.sort_by,
              order_by: this.desc ? "desc" : "asc",
            }
          )
          .then((response) => {
            response.data.rows.map((doc) => {
              doc.relations.selected = false;
            });

            /*response.data.rows = this.$_.orderBy(
              response.data.rows,
              this.sort_by,
              this.desc ? "desc" : "asc"
            );*/

            // Set all selected documents

            response.data.rows.map((doc) => {
              if (selected_documents.indexOf(doc._id) > -1) {
                doc.relations.selected = true;
              }
            });

            this.documents = response.data.rows;

            project.relations.total_documents = response.data.total_rows;

            if (
              this.currentproject &&
              project &&
              project._id == this.currentproject._id
            ) {
              this.currentproject = project;
            }
            this.loadingDocuments = false;
            this.is_fetching_documents = false;

            console.log(this.search_request);
          });
      }
    },

    ctrim(s, c) {
      if (c === "]") c = "\\]";
      if (c === "^") c = "\\^";
      if (c === "\\") c = "\\\\";
      return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
    },

    importFiles(conf) {
      this.axios
        .post(this.base_url + "/job/import", {
          configuration: {
            project_id: this.currentproject._id,
            project_directory: conf.dir_path,
            should_be_splitted: conf.should_be_splitted,
            overwrite_existing_files: conf.overwrite_existing_files,
            files: conf.files,
            compression_strategy: conf.compression_strategy,
            compression_min_filesize_mb: conf.compression_min_filesize_mb
          },
        })
        .then((response) => {
          this.$bvToast.toast("Import gestartet", {
            title: "Import gestartet",  
            variant: "primary",
            autoHideDelay: 1000,
          });

          let jobs = localStorage.getItem("jobs");

          if (jobs) {
            jobs = JSON.parse(jobs);
            jobs.push(response.data);
          } else {
            jobs = [response.data];
          }
          localStorage.setItem("jobs", JSON.stringify(jobs));

          this.getDocuments(this.currentproject);
        });
    },

    deleteproject(project) {
      this.$bvModal
        .msgBoxConfirm(
          "Soll das Projekt und alle zugehörigen Dokumente gelöscht werden?",
          { buttonSize: "sm", variant: "danger" }
        )
        .then((value) => {
          if (value) {
            this.axios
              .delete(this.base_url + "/projects/" + project._id)
              .then((response) => {
                this.currentproject = null;
                this.selectedProject = null;
                this.$route.params.id = null;
                this.$router.replace({ path: "/dashboard" });
                this.$bvToast.toast(project.name, {
                  title: "Löschen erfolgreich",
                  variant: "primary",
                  autoHideDelay: 1000,
                });
                this.getProjects();
              });
          }
        });
    },

    deleteDocument(project, document) {
      this.$bvModal
        .msgBoxConfirm("Soll das Dokument wirklich gelöscht werden?", {
          buttonSize: "sm",
        })
        .then((value) => {
          if (value) {
            this.axios
              .delete(
                this.base_url +
                  "/projects/" +
                  project._id +
                  "/documents/" +
                  document._id
              )
              .then((response) => {
                this.$bvToast.toast(document.filename, {
                  title: "Löschen erfolgreich",
                  variant: "primary",
                  autoHideDelay: 1000,
                });

                this.getDocuments(project);
              });
          }
        });
    },

    updateproject(project) {
      this.axios
        .put(this.base_url + "/projects/" + project._id, project)
        .then((response) => {
          this.getProjects();
        });
    },


    init() {
      this.form = this.$_.clone(this.init_form);
      this.getProjects();
      this.axios.get(this.base_url + "/options").then((response) => {
        this.options = response.data;
      });

      this.axios
        .get(this.base_url + "/docsense/checklists")
        .then((response) => {
          this.checklists = response.data;
        });

      this.axios
        .get(this.base_url + "/configuration/instance")
        .then((response) => {
          this.config = response.data;
        });

      this.interval = setInterval(() => {
        if(this.bulk_operation) return;
        if (this.is_fetching_documents) return;
        if (this.currentproject)
          this.getDocuments(this.currentproject, null, false);
      }, 20000);

    
    },

    beforeUnmount() {
      clearInterval(this.interval);
    },
  },
  watch: {
   

    "$route.query.page": function (newv, oldv) {
      if (newv == "pre_list") {
        setTimeout(() => {
          
          
            this.$router.replace({ query: { page: "list" } });
        
         
        }, 100);
      }
    },

    "show_automatically_added": function() {
      // Reset to first page when toggling visibility of automatically added items
      this.currentListPage = 1;
    },
    
  },

  async mounted() {
    this.init();
  },
};
</script>
<style lang="scss">
a.subm {
  text-align: center;
  padding: 5px;
  margin: 0;
  color: white;
  min-width: 100px;
}

.submactive {
  border-radius: 5px 5px 0 0;
  background-color: #f8f9fe;
  color: #000 !important;
  padding: 5px;
}

thead {
  background-color: hsl(207, 23%, 92%);
  th {
    background-color: hsl(207, 23%, 92%);
  }
}
.card-height {
  height: 300px; /* adjust as needed */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: 19%; /* adjust as needed to get the desired number of items per row */
  margin: 0.5%; /* adjust as needed to add spacing between items */
}

.active_project {
  background-color: hsl(207, 23%, 92%);
}

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}

.dropzone-multiple .dz-message {
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: transparent !important;
}

.dz-message {
  background-color: transparent !important;
}

.b-toast-primary {
  box-shadow: 0 0 0 5px hsl(207, 23%, 92%) !important;
  position: fixed;
  border-radius: 0px;
  width: 300px;
  right: 20px;
  top: 10px;
  .toast-header,
  .toast-body {
    background-color: #fff !important;
    font-size: 12px;
    color: #000;
  }
  background-color: #fff;
  padding: 10px;
}

.dz-preview {
  position: fixed;
  opacity: 1;
  z-index: 1000;
  top: 60px;
  max-height: 600px;
  overflow-y: scroll;
  overflow-x: hidden;
  right: 20px;
  width: 300px;
  background-color: #fff;
  .list-group-item {
    border: none;
    padding: 5px !important;
  }

  .avatar {
    display: none;
  }
}

.clamp-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.clamp-2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 500px;
}

.dropzone {
  h4 {
    max-width: 150px;
    font-size: 12px;

    overflow: hidden;
    text-overflow: ellipsis;
  }

  border-radius: 5px;
  border: 1px dashed #ccc;
  border-image: none;

  margin-left: auto;
  margin-right: auto;

  .dz-button {
    color: #212529;
    background-color: #f7fafc;
    border-color: #f7fafc;
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
      0 1px 3px rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    line-height: 1.5;
    border-radius: 0.25rem;
  }
}

.custom-select-dropdown {
  /* Set the maximum height */
  max-height: 500px;

  /* Enable vertical scrolling if content exceeds max-height */
  overflow-y: auto;
}

/* Optional: Customize the scrollbar for better aesthetics */
.custom-select-dropdown .el-scrollbar__wrap {
  max-height: 500px;
  overflow-y: auto;
}

// Pagination styles
.pagination {
  margin-bottom: 0;
  
  .page-item .page-link {
    padding: 0.2rem 0.5rem;
    font-size: 0.8rem;
  }
  
  .page-item.active .page-link {
    background-color: #5e72e4;
    border-color: #5e72e4;
  }
}

</style>
